// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Outfit:wght@600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --landing-bg: #0b0f1a;
  --landing-surface: #141b2d;
  --landing-surface-alt: #1a2238;
  --landing-border: rgba(255, 255, 255, 0.08);
  --landing-text: #e8ecf4;
  --landing-muted: #8b95a8;
  --landing-accent: #f5b942;
  --landing-accent-hover: #ffc857;
  --landing-cyan: #3dd6c8;
  --landing-purple: #7c6cf0;
  --landing-success: #34d399;
  --landing-error: #f87171;
}

.landing,
.game-page {
  min-height: 100vh;
  background: var(--landing-bg);
  color: var(--landing-text);
  font-family: "DM Sans", -apple-system, BlinkMacSystemFont, sans-serif;
  overflow-x: hidden;
}

/* Nav */
.landing-nav {
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(12px);
  background: rgba(11, 15, 26, 0.85);
  border-bottom: 1px solid var(--landing-border);
}

.landing-nav-inner {
  max-width: 72rem;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.landing-logo {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  color: var(--landing-text);
  text-decoration: none;
}

.landing-logo-icon {
  display: grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, var(--landing-accent), #e8940a);
  color: var(--landing-bg);
  font-weight: 800;
  font-size: 1.125rem;
}

.landing-logo-accent {
  color: var(--landing-accent);
}

.landing-nav-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.landing-nav-links a {
  color: var(--landing-muted);
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 500;
  transition: color 0.2s;
}

.landing-nav-links a:hover {
  color: var(--landing-text);
}

.landing-nav-cta {
  padding: 0.5rem 1.125rem !important;
  border-radius: 9999px;
  background: var(--landing-accent) !important;
  color: var(--landing-bg) !important;
  font-weight: 600 !important;
}

.landing-nav-cta:hover {
  background: var(--landing-accent-hover) !important;
  color: var(--landing-bg) !important;
}

/* Hero */
.landing-hero {
  position: relative;
  max-width: 72rem;
  margin: 0 auto;
  padding: 4rem 1.5rem 6rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

@media (min-width: 960px) {
  .landing-hero {
    grid-template-columns: 1.1fr 0.9fr;
    padding-top: 5rem;
  }
}

.landing-hero-glow {
  position: absolute;
  top: -8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 40rem;
  height: 40rem;
  background: radial-gradient(circle, rgba(124, 108, 240, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.landing-hero-content {
  position: relative;
}

.landing-eyebrow {
  display: inline-block;
  margin-bottom: 1.25rem;
  padding: 0.375rem 0.875rem;
  border-radius: 9999px;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface);
  color: var(--landing-cyan);
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.landing-headline {
  font-family: "Outfit", sans-serif;
  font-size: clamp(2.25rem, 5vw, 3.5rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
}

.landing-headline-accent {
  background: linear-gradient(90deg, var(--landing-accent), var(--landing-cyan));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.landing-subheadline {
  max-width: 32rem;
  margin: 0 0 2rem;
  color: var(--landing-muted);
  font-size: 1.125rem;
  line-height: 1.65;
}

.landing-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.875rem;
  margin-bottom: 2.5rem;
}

.landing-btn-primary,
.landing-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border-radius: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.15s, background 0.15s;
}

.landing-btn-primary {
  background: linear-gradient(135deg, var(--landing-accent), #e8940a);
  color: var(--landing-bg);
  box-shadow: 0 4px 24px rgba(245, 185, 66, 0.3);
}

.landing-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(245, 185, 66, 0.4);
  color: var(--landing-bg);
}

.landing-btn-secondary {
  border: 1px solid var(--landing-border);
  background: var(--landing-surface);
  color: var(--landing-text);
}

.landing-btn-secondary:hover {
  background: var(--landing-surface-alt);
  color: var(--landing-text);
}

.landing-btn-large {
  padding: 1rem 2rem;
  font-size: 1.0625rem;
}

.landing-btn-inline {
  margin-top: 1.5rem;
}

.landing-hero-stats {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.landing-stat {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.landing-stat strong {
  font-family: "Outfit", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--landing-accent);
}

.landing-stat span {
  font-size: 0.8125rem;
  color: var(--landing-muted);
}

.landing-stat-divider {
  width: 1px;
  height: 2rem;
  background: var(--landing-border);
}

/* Preview card */
.landing-hero-card {
  position: relative;
  animation: landing-float 6s ease-in-out infinite;
}

@keyframes landing-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.landing-preview {
  background: var(--landing-surface);
  border: 1px solid var(--landing-border);
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
}

.landing-preview-header {
  display: flex;
  gap: 0.375rem;
  margin-bottom: 1.25rem;
}

.landing-preview-dot {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: var(--landing-border);
}

.landing-preview-timer {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 3px solid var(--landing-cyan);
  background: rgba(61, 214, 200, 0.1);
  font-family: "Outfit", sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--landing-cyan);
}

.landing-preview-question {
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 500;
  margin: 0 0 1rem;
  line-height: 1.5;
}

.landing-preview-answers {
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.landing-preview-answers li {
  padding: 0.625rem 0.875rem;
  border-radius: 0.5rem;
  border: 1px solid var(--landing-border);
  font-size: 0.8125rem;
  color: var(--landing-muted);
}

.landing-preview-answers li:first-child {
  border-color: rgba(61, 214, 200, 0.5);
  background: rgba(61, 214, 200, 0.08);
  color: var(--landing-cyan);
}

.landing-preview-progress {
  height: 4px;
  border-radius: 9999px;
  background: var(--landing-surface-alt);
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.landing-preview-progress-bar {
  width: 35%;
  height: 100%;
  border-radius: 9999px;
  background: linear-gradient(90deg, var(--landing-purple), var(--landing-cyan));
}

.landing-preview-meta {
  text-align: center;
  font-size: 0.75rem;
  color: var(--landing-muted);
  margin: 0;
}

/* Sections */
.landing-section {
  padding: 5rem 1.5rem;
}

.landing-section-alt {
  background: var(--landing-surface);
  border-top: 1px solid var(--landing-border);
  border-bottom: 1px solid var(--landing-border);
}

.landing-section-inner {
  max-width: 72rem;
  margin: 0 auto;
}

.landing-section-eyebrow {
  color: var(--landing-cyan);
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}

.landing-section-title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  margin: 0 0 0.75rem;
  letter-spacing: -0.02em;
}

.landing-section-desc {
  max-width: 36rem;
  color: var(--landing-muted);
  font-size: 1.0625rem;
  line-height: 1.65;
  margin: 0 0 2.5rem;
}

.landing-features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}

@media (min-width: 640px) {
  .landing-features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .landing-features-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.landing-feature-card {
  padding: 1.5rem;
  border-radius: 1rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface);
  transition: border-color 0.2s, transform 0.2s;
}

.landing-section:not(.landing-section-alt) .landing-feature-card {
  background: var(--landing-surface-alt);
}

.landing-feature-card:hover {
  border-color: rgba(245, 185, 66, 0.3);
  transform: translateY(-4px);
}

.landing-feature-icon {
  font-size: 1.75rem;
  display: block;
  margin-bottom: 0.875rem;
}

.landing-feature-card h3 {
  font-family: "Outfit", sans-serif;
  font-size: 1.0625rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.landing-feature-card p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--landing-muted);
  line-height: 1.6;
}

/* Steps */
.landing-steps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2.5rem;
}

@media (min-width: 768px) {
  .landing-steps {
    grid-template-columns: repeat(3, 1fr);
  }
}

.landing-step {
  position: relative;
  padding-top: 0.5rem;
}

.landing-step-number {
  display: block;
  font-family: "Outfit", sans-serif;
  font-size: 2.5rem;
  font-weight: 800;
  color: rgba(245, 185, 66, 0.2);
  line-height: 1;
  margin-bottom: 0.75rem;
}

.landing-step h3 {
  font-family: "Outfit", sans-serif;
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.landing-step p {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--landing-muted);
  line-height: 1.6;
}

/* Categories */
.landing-categories-block {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  align-items: center;
}

@media (min-width: 768px) {
  .landing-categories-block {
    grid-template-columns: 1fr 1fr;
  }
}

.landing-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

@media (min-width: 480px) {
  .landing-category-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

.landing-category-list li {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.875rem 1rem;
  border-radius: 0.625rem;
  border: 1px solid var(--landing-border);
  background: var(--landing-surface-alt);
  font-size: 0.9375rem;
  font-weight: 500;
}

.landing-category-bullet {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: var(--landing-accent);
  flex-shrink: 0;
}

/* CTA banner */
.landing-cta-banner {
  padding: 5rem 1.5rem;
  background: linear-gradient(135deg, rgba(124, 108, 240, 0.15), rgba(61, 214, 200, 0.08));
  border-top: 1px solid var(--landing-border);
}

.landing-cta-inner {
  max-width: 40rem;
  margin: 0 auto;
  text-align: center;
}

.landing-cta-inner h2 {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  margin: 0 0 0.75rem;
}

.landing-cta-inner p {
  color: var(--landing-muted);
  font-size: 1.0625rem;
  margin: 0 0 2rem;
}

/* Footer */
.landing-footer {
  padding: 2rem 1.5rem;
  border-top: 1px solid var(--landing-border);
  text-align: center;
}

.landing-footer p {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--landing-muted);
}

@media (max-width: 640px) {
  .landing-nav-links a:not(.landing-nav-cta) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/landing.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;EAC9B,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mEAAmE;EACnE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,4CAA4C;EAC5C,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;AACrC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;IAClC,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8EAA8E;EAC9E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,mEAAmE;EACnE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,sBAAsB;EACtB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,uCAAuC;EACvC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,8EAA8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,aAAa;AACb;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,wFAAwF;EACxF,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Outfit:wght@600;700;800&display=swap\");\n\n:root {\n  --landing-bg: #0b0f1a;\n  --landing-surface: #141b2d;\n  --landing-surface-alt: #1a2238;\n  --landing-border: rgba(255, 255, 255, 0.08);\n  --landing-text: #e8ecf4;\n  --landing-muted: #8b95a8;\n  --landing-accent: #f5b942;\n  --landing-accent-hover: #ffc857;\n  --landing-cyan: #3dd6c8;\n  --landing-purple: #7c6cf0;\n  --landing-success: #34d399;\n  --landing-error: #f87171;\n}\n\n.landing,\n.game-page {\n  min-height: 100vh;\n  background: var(--landing-bg);\n  color: var(--landing-text);\n  font-family: \"DM Sans\", -apple-system, BlinkMacSystemFont, sans-serif;\n  overflow-x: hidden;\n}\n\n/* Nav */\n.landing-nav {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  backdrop-filter: blur(12px);\n  background: rgba(11, 15, 26, 0.85);\n  border-bottom: 1px solid var(--landing-border);\n}\n\n.landing-nav-inner {\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 1rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.landing-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  font-family: \"Outfit\", sans-serif;\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: var(--landing-text);\n  text-decoration: none;\n}\n\n.landing-logo-icon {\n  display: grid;\n  place-items: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  background: linear-gradient(135deg, var(--landing-accent), #e8940a);\n  color: var(--landing-bg);\n  font-weight: 800;\n  font-size: 1.125rem;\n}\n\n.landing-logo-accent {\n  color: var(--landing-accent);\n}\n\n.landing-nav-links {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.landing-nav-links a {\n  color: var(--landing-muted);\n  text-decoration: none;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.landing-nav-links a:hover {\n  color: var(--landing-text);\n}\n\n.landing-nav-cta {\n  padding: 0.5rem 1.125rem !important;\n  border-radius: 9999px;\n  background: var(--landing-accent) !important;\n  color: var(--landing-bg) !important;\n  font-weight: 600 !important;\n}\n\n.landing-nav-cta:hover {\n  background: var(--landing-accent-hover) !important;\n  color: var(--landing-bg) !important;\n}\n\n/* Hero */\n.landing-hero {\n  position: relative;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 4rem 1.5rem 6rem;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n@media (min-width: 960px) {\n  .landing-hero {\n    grid-template-columns: 1.1fr 0.9fr;\n    padding-top: 5rem;\n  }\n}\n\n.landing-hero-glow {\n  position: absolute;\n  top: -8rem;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40rem;\n  height: 40rem;\n  background: radial-gradient(circle, rgba(124, 108, 240, 0.18) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.landing-hero-content {\n  position: relative;\n}\n\n.landing-eyebrow {\n  display: inline-block;\n  margin-bottom: 1.25rem;\n  padding: 0.375rem 0.875rem;\n  border-radius: 9999px;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface);\n  color: var(--landing-cyan);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.landing-headline {\n  font-family: \"Outfit\", sans-serif;\n  font-size: clamp(2.25rem, 5vw, 3.5rem);\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  margin: 0 0 1.25rem;\n}\n\n.landing-headline-accent {\n  background: linear-gradient(90deg, var(--landing-accent), var(--landing-cyan));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.landing-subheadline {\n  max-width: 32rem;\n  margin: 0 0 2rem;\n  color: var(--landing-muted);\n  font-size: 1.125rem;\n  line-height: 1.65;\n}\n\n.landing-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.875rem;\n  margin-bottom: 2.5rem;\n}\n\n.landing-btn-primary,\n.landing-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  border-radius: 0.75rem;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: transform 0.15s, box-shadow 0.15s, background 0.15s;\n}\n\n.landing-btn-primary {\n  background: linear-gradient(135deg, var(--landing-accent), #e8940a);\n  color: var(--landing-bg);\n  box-shadow: 0 4px 24px rgba(245, 185, 66, 0.3);\n}\n\n.landing-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 32px rgba(245, 185, 66, 0.4);\n  color: var(--landing-bg);\n}\n\n.landing-btn-secondary {\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface);\n  color: var(--landing-text);\n}\n\n.landing-btn-secondary:hover {\n  background: var(--landing-surface-alt);\n  color: var(--landing-text);\n}\n\n.landing-btn-large {\n  padding: 1rem 2rem;\n  font-size: 1.0625rem;\n}\n\n.landing-btn-inline {\n  margin-top: 1.5rem;\n}\n\n.landing-hero-stats {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.landing-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.landing-stat strong {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--landing-accent);\n}\n\n.landing-stat span {\n  font-size: 0.8125rem;\n  color: var(--landing-muted);\n}\n\n.landing-stat-divider {\n  width: 1px;\n  height: 2rem;\n  background: var(--landing-border);\n}\n\n/* Preview card */\n.landing-hero-card {\n  position: relative;\n  animation: landing-float 6s ease-in-out infinite;\n}\n\n@keyframes landing-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n.landing-preview {\n  background: var(--landing-surface);\n  border: 1px solid var(--landing-border);\n  border-radius: 1.25rem;\n  padding: 1.5rem;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);\n}\n\n.landing-preview-header {\n  display: flex;\n  gap: 0.375rem;\n  margin-bottom: 1.25rem;\n}\n\n.landing-preview-dot {\n  width: 0.625rem;\n  height: 0.625rem;\n  border-radius: 50%;\n  background: var(--landing-border);\n}\n\n.landing-preview-timer {\n  width: 4rem;\n  height: 4rem;\n  margin: 0 auto 1rem;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 3px solid var(--landing-cyan);\n  background: rgba(61, 214, 200, 0.1);\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--landing-cyan);\n}\n\n.landing-preview-question {\n  text-align: center;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  margin: 0 0 1rem;\n  line-height: 1.5;\n}\n\n.landing-preview-answers {\n  list-style: none;\n  margin: 0 0 1rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.landing-preview-answers li {\n  padding: 0.625rem 0.875rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--landing-border);\n  font-size: 0.8125rem;\n  color: var(--landing-muted);\n}\n\n.landing-preview-answers li:first-child {\n  border-color: rgba(61, 214, 200, 0.5);\n  background: rgba(61, 214, 200, 0.08);\n  color: var(--landing-cyan);\n}\n\n.landing-preview-progress {\n  height: 4px;\n  border-radius: 9999px;\n  background: var(--landing-surface-alt);\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.landing-preview-progress-bar {\n  width: 35%;\n  height: 100%;\n  border-radius: 9999px;\n  background: linear-gradient(90deg, var(--landing-purple), var(--landing-cyan));\n}\n\n.landing-preview-meta {\n  text-align: center;\n  font-size: 0.75rem;\n  color: var(--landing-muted);\n  margin: 0;\n}\n\n/* Sections */\n.landing-section {\n  padding: 5rem 1.5rem;\n}\n\n.landing-section-alt {\n  background: var(--landing-surface);\n  border-top: 1px solid var(--landing-border);\n  border-bottom: 1px solid var(--landing-border);\n}\n\n.landing-section-inner {\n  max-width: 72rem;\n  margin: 0 auto;\n}\n\n.landing-section-eyebrow {\n  color: var(--landing-cyan);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin: 0 0 0.75rem;\n}\n\n.landing-section-title {\n  font-family: \"Outfit\", sans-serif;\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  margin: 0 0 0.75rem;\n  letter-spacing: -0.02em;\n}\n\n.landing-section-desc {\n  max-width: 36rem;\n  color: var(--landing-muted);\n  font-size: 1.0625rem;\n  line-height: 1.65;\n  margin: 0 0 2.5rem;\n}\n\n.landing-features-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n}\n\n@media (min-width: 640px) {\n  .landing-features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 960px) {\n  .landing-features-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.landing-feature-card {\n  padding: 1.5rem;\n  border-radius: 1rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface);\n  transition: border-color 0.2s, transform 0.2s;\n}\n\n.landing-section:not(.landing-section-alt) .landing-feature-card {\n  background: var(--landing-surface-alt);\n}\n\n.landing-feature-card:hover {\n  border-color: rgba(245, 185, 66, 0.3);\n  transform: translateY(-4px);\n}\n\n.landing-feature-icon {\n  font-size: 1.75rem;\n  display: block;\n  margin-bottom: 0.875rem;\n}\n\n.landing-feature-card h3 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.0625rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem;\n}\n\n.landing-feature-card p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--landing-muted);\n  line-height: 1.6;\n}\n\n/* Steps */\n.landing-steps {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  margin-top: 2.5rem;\n}\n\n@media (min-width: 768px) {\n  .landing-steps {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.landing-step {\n  position: relative;\n  padding-top: 0.5rem;\n}\n\n.landing-step-number {\n  display: block;\n  font-family: \"Outfit\", sans-serif;\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: rgba(245, 185, 66, 0.2);\n  line-height: 1;\n  margin-bottom: 0.75rem;\n}\n\n.landing-step h3 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem;\n}\n\n.landing-step p {\n  margin: 0;\n  font-size: 0.9375rem;\n  color: var(--landing-muted);\n  line-height: 1.6;\n}\n\n/* Categories */\n.landing-categories-block {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2.5rem;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .landing-categories-block {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.landing-category-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n}\n\n@media (min-width: 480px) {\n  .landing-category-list {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.landing-category-list li {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.875rem 1rem;\n  border-radius: 0.625rem;\n  border: 1px solid var(--landing-border);\n  background: var(--landing-surface-alt);\n  font-size: 0.9375rem;\n  font-weight: 500;\n}\n\n.landing-category-bullet {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  background: var(--landing-accent);\n  flex-shrink: 0;\n}\n\n/* CTA banner */\n.landing-cta-banner {\n  padding: 5rem 1.5rem;\n  background: linear-gradient(135deg, rgba(124, 108, 240, 0.15), rgba(61, 214, 200, 0.08));\n  border-top: 1px solid var(--landing-border);\n}\n\n.landing-cta-inner {\n  max-width: 40rem;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.landing-cta-inner h2 {\n  font-family: \"Outfit\", sans-serif;\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  margin: 0 0 0.75rem;\n}\n\n.landing-cta-inner p {\n  color: var(--landing-muted);\n  font-size: 1.0625rem;\n  margin: 0 0 2rem;\n}\n\n/* Footer */\n.landing-footer {\n  padding: 2rem 1.5rem;\n  border-top: 1px solid var(--landing-border);\n  text-align: center;\n}\n\n.landing-footer p {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--landing-muted);\n}\n\n@media (max-width: 640px) {\n  .landing-nav-links a:not(.landing-nav-cta) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
